// Produces a square cropped JPEG data URL using a crop rectangle (in pixels)
// returned by react-easy-crop. `maxSize` caps the output dimension.
export default function cropImage(src, cropPixels, maxSize = 512) {
  return new Promise((resolve, reject) => {
    if (!src || !cropPixels) return reject(new Error("Missing source or crop"));
    const img = new Image();
    img.crossOrigin = "anonymous";
    img.onload = () => {
      const outputSize = Math.min(maxSize, Math.floor(cropPixels.width));
      const canvas = document.createElement("canvas");
      canvas.width = outputSize;
      canvas.height = outputSize;
      const ctx = canvas.getContext("2d");
      ctx.drawImage(
        img,
        cropPixels.x, cropPixels.y, cropPixels.width, cropPixels.height,
        0, 0, outputSize, outputSize,
      );
      resolve(canvas.toDataURL("image/jpeg", 0.85));
    };
    img.onerror = () => reject(new Error("Could not load image"));
    img.src = src;
  });
}
